import { Card, CardContent } from '@/components/ui/card';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

export const StatCard = ({ title, value, icon: Icon, trend, trendValue, description, onClick }) => {
  const isPositive = trend === 'up';

  return (
    <Card 
      className={`card-hover ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}`}
      onClick={onClick}
    >
      <CardContent className="pt-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          {/* Text Content */}
          <div className="flex-1">
            <p className="text-sm sm:text-base font-medium text-muted-foreground">{title}</p>
            <h3 className="text-xl sm:text-2xl font-bold mt-1 sm:mt-2">{value}</h3>

            {description && (
              <p className="text-xs sm:text-sm text-muted-foreground mt-1">{description}</p>
            )}

            {trendValue && (
              <div className="flex items-center gap-1 mt-2">
                {isPositive ? (
                  <ArrowUpRight className="h-4 w-4 text-success" />
                ) : (
                  <ArrowDownRight className="h-4 w-4 text-destructive" />
                )}
                <span
                  className={`text-xs sm:text-sm font-medium ${
                    isPositive ? 'text-success' : 'text-destructive'
                  }`}
                >
                  {trendValue}
                </span>
              </div>
            )}
          </div>

          {/* Icon */}
          {Icon && (
            <div className="flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-lg bg-primary/10 text-primary flex-shrink-0">
              <Icon className="h-5 w-5 sm:h-6 sm:w-6" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
